module.exports = __webpack_public_path__ + "img/search-header-nav-below-nissan.aa1caf7d.png";